export interface TechpacksState {
  techpacks: TechpacksDictionary
  loading?: boolean
  errorMessage?: string
}

export const state: TechpacksState = {
  techpacks: {},
  loading: false
}

export type TechpackRowItem = {
  _id: string
  name: string
  productName: string
  productCode: string
  addedAt: string | Date
  details: TechpackRowItemMetadata
  folderName: string
  folderId: string
}

type TechpackRowItemMetadata = {
  attachmentCount: number
}

type FolderId = string
export type TechpacksDictionary = Record<FolderId, Array<TechpackRowItem>>
